import React from 'react'
import { assetsArchivesModel } from '../assetsArchivesModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import { useDictModel } from '@/views/base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = assetsArchivesModel()

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '物资编码',
            fieldName: 'code',
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '物资名称',
            fieldName: 'name',
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '物资类型',
            fieldName: 'typeCode',
            options: getSelectedDictOne(DictCodeEnmu.ASSETS_MATERIAL_TYPE),
            showSearch:true,
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '规格型号',
            fieldName: 'model',
        },
    ]


    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
